import React from "react";
import { Star, Heart, Play, ArrowRight, ExternalLink, Download } from "lucide-react";

export function Card({ item, wished, onWish, onBuy, onPartner, onOpen, progress, rank }) {
  const isHerb = item.category === "herb";
  const isCourse = item.category === "course";
  const isDigital = item.category === "digital";
  const isMember = item.category === "membership";
  const tagColor = item.tagColor || "gold";

  const CTA = () => {
    if (isHerb) {
      const uk = item.affiliate_url, us = item.affiliate_url_us;
      if (uk && us) return (
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn btn-soft cta" style={{ flex: 1 }} data-testid={`shop-uk-${item.id}`} onClick={() => onPartner(item, "uk")}>Shop UK <ExternalLink size={13} /></button>
          <button className="btn btn-soft cta" style={{ flex: 1 }} data-testid={`shop-us-${item.id}`} onClick={() => onPartner(item, "us")}>Shop US <ExternalLink size={13} /></button>
        </div>
      );
      return <button className="btn btn-soft block cta" data-testid={`shop-${item.id}`} onClick={() => onPartner(item)}>Shop <ExternalLink size={14} /></button>;
    }
    if (isDigital) return <button className="btn btn-gold block cta" onClick={() => onBuy(item)}>Download <Download size={14} /></button>;
    if (isMember) return <button className="btn btn-gold block cta" onClick={() => onBuy(item)}>Join ELY Plus</button>;
    if (item.category === "therapy") return <button className="btn btn-primary block cta" onClick={() => onBuy(item)}>Book Session</button>;
    return <button className="btn btn-primary block cta" onClick={() => (isCourse ? onOpen(item) : onBuy(item))}><Play size={14} /> Start Course</button>;
  };

  return (
    <div className="top10">
      {rank ? <span className="rank">{rank}</span> : null}
      <article className="card" style={{ flex: 1 }}>
        <div className={`art ${item.color || "art-gold"}`}>
          <span className={`tag tag-${tagColor}`}>{item.tag || item.category}</span>
          <button className="wish" onClick={() => onWish(item)} aria-label="My List">
            <Heart size={15} fill={wished ? "currentColor" : "none"} />
          </button>
          {isCourse && <span className="hover-play" aria-hidden="true"><Play size={22} fill="currentColor" /></span>}
          {progress > 0 && <div className="progress"><span style={{ width: `${progress}%` }} /></div>}
        </div>
        <div className="card-body">
          <h3>{item.title}</h3>
          <p className="desc">{item.desc}</p>
          <div className="chips">
            <span className="chip star"><Star size={12} fill="currentColor" /> {item.rating}</span>
            {item.price_gbp ? <span className="chip price">£{item.price_gbp}</span> : <span className="chip">{item.partner}</span>}
            {item.duration && <span className="chip">{item.duration}</span>}
          </div>
          <CTA />
          {isCourse && <button className="text-btn" onClick={() => onOpen(item)} style={{ alignSelf: "flex-start" }}>Preview lessons →</button>}
        </div>
      </article>
    </div>
  );
}
